{
  "testEnvironment": "Testiympäristö",
  "currency": {
    "czk": "Kč",
    "eur": "€",
    "usd": "$"
  },
  "dashboardSidebarCollapse": {
    "expand": "Laajenna sivupalkki",
    "collapse": "Pienennä sivupalkki"
  },
  "dashboardSidebarToggle": {
    "close": "Sulje sivupalkki",
    "open": "Avaa sivupalkki"
  },
  "navigation": {
    "dashboard": "Omat tehtäväni",
    "quotations": "Tarjoukset",
    "workflows": "Työjono",
    "clients": "Asiakkaat",
    "users": "Käyttäjät",
    "sapImport": "SAP-tuonti",
    "deadLetters": "Kuolleet viestit",
    "settings": "Asetukset",
    "noAccess": "Pääsy estetty",
    "workflow": "Työnkulku"
  },
  "sapImport": {
    "title": "SAP-tuonti",
    "description": "Yleiskatsaus SAP:sta tuoduista tiedoista.",
    "table": {
      "fileName": "Tiedostonimi",
      "created": "Luotu",
      "size": "Koko",
      "actions": "Toiminnot",
      "showing": "Tulokset",
      "of": "/",
      "loading": "Ladataan...",
      "search": "Hae tiedostonimen mukaan"
    },
    "actions": {
      "preview": "Esikatselu",
      "download": "Lataa",
      "validate": "Vahvista"
    },
    "preview": {
      "title": "JSON-esikatselu",
      "copyRaw": "Kopioi JSON",
      "copied": "Kopioitu",
      "search": "Hae JSON:sta",
      "matchCount": "{current} / {total}",
      "noMatches": "Ei tuloksia",
      "expandAll": "Laajenna kaikki",
      "collapseAll": "Kutista kaikki"
    },
    "empty": {
      "title": "Tiedostoja ei löytynyt",
      "description": "SAP-tiedostoja ei ole vielä tuotu."
    },
    "error": {
      "loadFailed": "SAP-tiedostojen lataaminen epäonnistui.",
      "previewFailed": "Tiedoston esikatselun lataaminen epäonnistui.",
      "downloadFailed": "Tiedoston lataaminen epäonnistui."
    },
    "validation": {
      "valid": "Tiedosto on kelvollinen",
      "modalTitle": "Validointivirheet",
      "errorCount": "{count} virhe(ttä)",
      "field": "Kenttä",
      "errorCode": "Virhekoodi",
      "errorMessage": "Viesti",
      "notFound": "Tiedostoa ei löytynyt",
      "unavailable": "Validointi ei ole tällä hetkellä käytettävissä",
      "failed": "Validointi epäonnistui"
    }
  },
  "deadLetters": {
    "filters": {
      "messageType": "Viestityyppi",
      "exceptionType": "Poikkeustyyppi",
      "exceptionMessage": "Poikkeusviesti",
      "clear": "Tyhjennä suodattimet"
    },
    "table": {
      "showing": "Tulokset",
      "of": "/",
      "loading": "Ladataan...",
      "messageType": "Viestityyppi",
      "exceptionType": "Poikkeus",
      "exceptionMessage": "Poikkeusviesti",
      "sentAt": "Lähetetty",
      "replayable": "Uudelleentoistettava",
      "actions": "Toiminnot"
    },
    "actions": {
      "replay": "Toista uudelleen",
      "delete": "Poista",
      "clearSelection": "Tyhjennä valinta",
      "replayOne": "Toista tämä viesti uudelleen",
      "deleteOne": "Poista tämä viesti",
      "selected": "valittu"
    },
    "confirm": {
      "replayTitle": "Toista viestit uudelleen",
      "replayMessage": "Haluatko varmasti toistaa {count} viesti(ä) uudelleen? Ne lisätään uudelleen käsittelyjonoon.",
      "deleteTitle": "Poista viestit",
      "deleteMessage": "Haluatko varmasti poistaa {count} viesti(ä) pysyvästi? Tätä toimintoa ei voi kumota.",
      "deleteSingleMessage": "Haluatko varmasti poistaa tämän viestin pysyvästi? Tätä toimintoa ei voi kumota."
    },
    "notification": {
      "replayed": "Viestit lisätty uudelleentoistettaviksi onnistuneesti.",
      "deleted": "Viestit poistettu onnistuneesti.",
      "replayFailed": "Viestien uudelleentoisto epäonnistui.",
      "deleteFailed": "Viestien poistaminen epäonnistui."
    },
    "empty": {
      "title": "Kuolleita viestejä ei löytynyt",
      "description": "Kaikki viestit käsitellään normaalisti."
    },
    "badge": {
      "yes": "Kyllä",
      "no": "Ei"
    }
  },
  "userMenu": {
    "settings": "Asetukset",
    "appearance": {
      "label": "Ulkoasu",
      "modes": {
        "light": "Vaalea",
        "dark": "Tumma"
      }
    },
    "auth": {
      "login": "Kirjaudu sisään",
      "logout": "Kirjaudu ulos",
      "notLoggedIn": "Ei kirjautunut"
    }
  },
  "notification": {
    "quotationInformationNoChanges": "Muutoksia ei löytynyt",
    "quotationInformationSaveSuccessfully": "Tarjoustiedot tallennettiin onnistuneesti",
    "quotationInformationSaveFailed": "Tarjoustietojen tallentaminen epäonnistui",
    "deliveryInformationSaveSuccessfully": "Toimitustiedot tallennettiin onnistuneesti",
    "deliveryInformationSaveFailed": "Toimitustietojen tallentaminen epäonnistui",
    "handoverInformationSaveSuccessfully": "Luovutustiedot tallennettiin onnistuneesti",
    "handoverInformationSaveFailed": "Luovutustietojen tallentaminen epäonnistui",
    "quotationApprovedSuccessfully": "Tarjous on hyväksytty",
    "orderApprovedSuccessfully": "Tilaus on hyväksytty",
    "deliveryApprovedSuccessfully": "Toimitus on hyväksytty",
    "quotationRejectedSuccessfully": "Tarjous on hylätty",
    "orderRejectedSuccessfully": "Tilaus on hylätty",
    "changesSaveSuccessfully": "Muutokset tallennettiin onnistuneesti",
    "changesSaveFailed": "Muutosten tallentaminen epäonnistui",
    "requestedDeliveryDateValidationError": "Pyydetty toimituspäivä on pakollinen kenttä",
    "tyreDeliveryConfirmedSuccessfully": "Rengastoimitus on vahvistettu",
    "notRegisteredUserApprovalLinkResent": "Hyväksyntälinkki on lähetetty uudelleen {emails}",
    "notRegisteredUserApprovalLinkNoExpired": "Vanhentuneita hyväksyntälinkkejä ei löytynyt uudelleenlähetettäväksi",
    "notRegisteredUserApprovalLinkResendFailed": "Hyväksyntälinkin uudelleenlähetys epäonnistui",
    "rejectFailed": "Työnkulun hylkääminen epäonnistui",
    "quotationRestartedSuccessfully": "Tarjous on käynnistetty uudelleen",
    "workflowUnparkedSuccessfully": "Työnkulku on jatkettu",
    "orderRestartedSuccessfully": "Tilaus on käynnistetty uudelleen",
    "restartFailed": "Työnkulun uudelleenkäynnistys epäonnistui"
  },
  "dashboard": {
    "searchPlaceholder": "Hae ulk. viitteellä tai kuvauksella",
    "requiringAction": {
      "title": "Vaatii toimenpiteitäsi",
      "viewAll": "Näytä kaikki",
      "client": "Asiakas",
      "supplier": "Toimittaja",
      "created": "Luotu",
      "approveMessage": "Hyväksy tai hylkää tarjous edistääksesi tilausta.",
      "openDetail": "Avaa tiedot"
    },
    "empty": {
      "title": "Ei määrättyjä tehtäviä",
      "description": "Sinulle ei ole tällä hetkellä toimenpiteitä vaativia työnkulkuja.",
      "viewAll": "Näytä kaikki työnkulut"
    }
  },
  "workflows": {
    "table": {
      "showing": "Tulokset",
      "of": "/",
      "loading": "Ladataan...",
      "columns": {
        "externalReference": "Ext. Reference",
        "status": "Status",
        "delivery": "Toimitus",
        "client": "Asiakas",
        "driver": "Kuljettaja",
        "description": "Kuvaus",
        "supplier": "Toimittaja",
        "manufacturer": "Valmistaja",
        "model": "Malli",
        "vehicle": "Ajoneuvo",
        "assignees": "Vastuuhenkilöt"
      },
      "filters": {
        "externalReference": "Filtteröi Ext. Reference",
        "status": "Filteröi Statuksen tai vauheen mukaan",
        "client": "Filtteröi asiakkaan mukaan",
        "driver": "Filtteröi kuljettajan mukaan",
        "description": "Filtteröi kuvauksen mukaan",
        "supplier": "Filtteröi toimittajan mukaan",
        "manufacturer": "Filtetröi valmistajan mukaan",
        "model": "Filtteröi mallin mukaan",
        "vehicle": "Filtteröi ajoneuvon mukaan",
        "assignee": "Filtteröi henkilön mukaan",
        "dateRange": "Valitse ajanjakso",
        "clearDateFilter": "Tyhjennä päiväsuodatin",
        "clear": "Tyhjennä"
      },
      "dateFilters": {
        "allDates": "Kaikki päivämäärät",
        "today": "Tänään",
        "thisWeek": "Kuluva viikko",
        "thisMonth": "Kuluva kuukausi",
        "thisYear": "Kuluva vuosi",
        "customRange": "Mukautettu ajanjakso"
      },
      "multipleSuppliers": "Useita toimittajia"
    },
    "assignedFilter": {
      "allWorkflows": "Kaikki työjonot",
      "assignedToMe": "Minulle osoitetut"
    }
  },
  "workflowDetail": {
    "header": {
      "detail": "Tiedot",
      "objectNumber": "Objektinumero",
      "purchaseOrderNumber": "Ostotilausnumero",
      "calculationNumber": "Laskelman numero",
      "quotationNumber": "Tarjousnumero",
      "updatedVersionTooltip": "Päivitetty versio (v{version})",
      "downloadCalculation": "Lataa laskelma",
      "downloadPurchaseOrder": "Lataa ostotilaus",
      "pdf": "PDF",
      "registrationProxy": "PDF",
      "downloadRegistrationProxy": "Lataa rekisteröinnin proxy",
      "pdfNotFound": "Asiakirjaa ei löytynyt.",
      "pdfDownloadError": "Asiakirjan lataus epäonnistui.",
      "reject": "Hylkää",
      "restart": "Käynnistä uudelleen",
      "viewQuotationData": "Näytä alkuperäiset tarjoustiedot"
    },
    "actions": {
      "cancel": "Peruuta",
      "save": "Tallenna",
      "edit": "Muokkaa",
      "unsavedChangesTitle": "Tallentamattomat muutokset",
      "unsavedChangesMessage": "Sinulla on tallentamattomia muutoksia. Haluatko hylätä ne?",
      "discard": "Hylkää",
      "continueEditing": "Jatka muokkausta"
    },
    "common": {
      "yes": "Kyllä",
      "no": "Ei",
      "select": "Valitse",
      "exclVat": "alv 0 %",
      "inclVat": "sis. alv",
      "months": "Kuukaudet",
      "annual": "Vuosittain",
      "total": "Yhteensä"
    },
    "tabs": {
      "overview": "Yleiskatsaus",
      "additionalInformation": "Lisätietoja",
      "documents": "Dokumentit",
      "notes": "Muistiinpanot",
      "eventHistory": "Tapahtumahistoria"
    },
    "overview": {
      "investmentPrice": "Kokonaisinvestointi",
      "monthlyPayment": "Kuukausikustannus",
      "contractSectionTitle": "Sopimus ja toimitus",
      "tyreSectionTitle": "Renkaat",
      "vehicleSectionTitle": "Ajoneuvo"
    },
    "meaningDeliveryDate": {
      "asap": "Mahdollisimman pian",
      "onDate": "Tiettynä päivänä (EQ)",
      "afterDate": "Päivän jälkeen (GE)",
      "beforeDate": "Ennen päivää (LE)"
    },
    "vehicle": {
      "vin": "VIN",
      "make": "Merkki",
      "makeName": "Merkin nimi",
      "code": "Koodi",
      "model": "Malli",
      "modelName": "Mallin nimi",
      "enginePower": "Moottorin teho",
      "upholstery": "Verhoilu",
      "color": "Väri",
      "material": "Materiaali",
      "homologation": "Homologointi",
      "wheelCount": "Pyörien lukumäärä",
      "seats": "Istumapaikat",
      "co2Emissions": "CO₂-päästöt",
      "category": "Kategoria",
      "exterior": "Ulkopuoli"
    },
    "tyreSpec": {
      "title": "Rengasspesifikaatio",
      "dimensions": "Mitat",
      "type": "Tyyppi",
      "width": "Leveys",
      "profile": "Profiili",
      "diameter": "Halkaisija",
      "speedIndex": "Nopeusindeksi",
      "loadIndex": "Kantavuusindeksi",
      "rimSensor": "RIM-anturi (TPMS)",
      "quantity": "Määrä",
      "pcs": "kpl",
      "pricing": "Hinnoittelu",
      "listPrice": "Listahinta",
      "discount": "Alennus",
      "netPrice": "Nettohinta",
      "perPiece": "per kappale",
      "total": "Yhteensä",
      "typeSummer": "Kesä",
      "typeWinter": "Talvi",
      "typeWinterStudded": "Talvi nastoilla",
      "typeAllSeason": "Ympärivuotinen"
    },
    "tyrePackage": {
      "title": "Rengaspaketti",
      "priceAfterDiscount": "Hinta alennuksen jälkeen",
      "discount": "Alennus",
      "tyresTitle": "Renkaat",
      "rimsTitle": "Vanteet",
      "tpmsTitle": "Rengaspaineanturit (TPMS)",
      "description": "Kuvaus",
      "dimensions": "Mitat",
      "diameter": "Halkaisija",
      "type": "Tyyppi",
      "brand": "Merkki",
      "quantity": "Kpl",
      "code": "Koodi"
    },
    "contract": {
      "product": "Tuote",
      "financialProduct": "Rahoitustuote",
      "commercialProduct": "Kaupallinen tuote",
      "duration": "Kesto",
      "mileage": "Kilometrit",
      "externalReference": "External Reference",
      "createdDate": "Luontipäivä",
      "quotationValidTo": "Voimassaolopäivä",
      "requestForRegistration": "Rekisteröintipyyntö",
      "driverSetReceipt": "Kuljettajan kuittaus",
      "techCertificateSend": "Teknisen todistuksen lähetys",
      "dealerExpectedDeliveryDate": "Arvioitu toimituspäivä",
      "meaningOfReqDeliveryDate": "Pyydetyn toimituspäivän merkitys",
      "requiredDeliveryDate": "Pyydetty toimituspäivä",
      "possibleDeliveryDate": "Mahdollinen toimituspäivä",
      "registrationNumber": "Rekisterinumero",
      "dealerOrderId": "Jälleenmyyjän tilaus-ID",
      "initialQuotationNumber": "Alkuperäisen tarjouksen numero",
      "handoverDate": "Luovutuspäivä",
      "registrationDate": "Rekisteröintipäivä",
      "handoverMileage": "Kilometrit luovutushetkellä",
      "initialMileage": "Alkukilometrit",
      "stockDealer": "Varasto – Jälleenmyyjä",
      "arrivedAtDealer": "Saapunut jälleenmyyjälle",
      "poolCar": "Yhteiskäyttöauto",
      "replacedCarRegNumber": "Korvaavan auton rekisterinumero",
      "replacedCarContractEnd": "Korvaavan auton sopimuksen päättyminen",
      "secondTyreSetStorageAddress": "Renkaiden säilytyspaikka",
      "secondTyreSetStorageDate": "Renkaiden säilytyspäivä"
    },
    "driver": {
      "title": "Kuljettaja",
      "id": "ID",
      "name": "Nimi",
      "phone": "Puhelin",
      "email": "Sähköposti",
      "staffId": "Henkilönumero",
      "selectDriver": "Valitse kuljettaja",
      "serviceUnavailable": "Palvelu ei ole käytettävissä",
      "carBenefitLevel": "Autoedun taso",
      "fullBenefitValue": "Vapaan edun arvo",
      "limitedBenefitValue": "Käyttöedun arvo",
      "benefitLevels": {
        "limited": "Käyttöetu",
        "full": "Vapaa etu"
      }
    },
    "contactForVehicle": {
      "title": "Ajoneuvon yhteyshenkilö",
      "id": "ID",
      "name": "Nimi",
      "phone": "Puhelin",
      "email": "Sähköposti",
      "serviceUnavailable": "Palvelu ei ole käytettävissä"
    },
    "client": {
      "title": "Asiakas",
      "name": "Nimi",
      "id": "ID",
      "contractNumber": "Sopimusnumero",
      "costCentreNumber": "Kustannuspaikan numero",
      "costCentre": "Kustannuspaikka",
      "serviceUnavailable": "Palvelu ei ole käytettävissä"
    },
    "supplier": {
      "title": "Toimittaja",
      "name": "Nimi",
      "id": "ID",
      "address": "Osoite",
      "email": "Sähköposti",
      "phone": "Puhelin",
      "salesPerson": "Myyjä",
      "usingEOrders": "Käyttää eOrdersia",
      "notUsingEOrders": "Ei käytä eOrdersia",
      "addEmailAddress": "Lisää sähköpostiosoite"
    },
    "purchaseOrderType": {
      "vehicle": "Ajoneuvo",
      "tyre": "Rengas"
    }
  },
  "additionalInfo": {
    "fuelCards": {
      "title": "Maksuvälineet",
      "cardType": "Maksuvälinetyyppi",
      "orderConfirmed": "Tilaus vahvistettu",
      "validFrom": "Voimassa alkaen",
      "deliveryDate": "Toimituspäivä",
      "status": "Status",
      "noCardsAvailable": "Maksuvälineitä ei saatavilla"
    },
    "services": {
      "title": "Palvelut",
      "serviceCode": "Palvelukoodi",
      "serviceName": "Palvelun nimi",
      "specification": "Yksityiskohdat",
      "included": "Sisältyy",
      "monthlyRate": "Kuukausihinta (alv 0 %)",
      "noServicesAvailable": "Ei palveluita valittuna"
    },
    "vehicle": {
      "title": "Ajoneuvo",
      "description": "Ajoneuvon kuvaus",
      "deliveryCost": "Toimituskulu",
      "registrationTax": "Auton autovero",
      "registrationCost": "Rekisteröintikulu"
    },
    "accessories": {
      "title": "Lisävarusteet ja laitteet",
      "titleAccessoriesOnly": "Lisävarusteet",
      "seqNumber": "#",
      "code": "Koodi",
      "description": "Lisävarusteen kuvaus",
      "standard": "Vakio",
      "manufacturer": "Valmistaja",
      "price": "Hinta",
      "afterDiscount": "Alennuksen jälkeen (alv 0 %)",
      "discount": "Alennus",
      "owner": "Omistaja",
      "noAccessoriesAvailable": "Ei lisävarusteita valittuna"
    },
    "options": {
      "title": "Lisälaitteet",
      "description": "Lisälaitteen kuvaus",
      "total": "Lisälaitteet yhteensä",
      "registrationTax": "Varusteiden autovero",
      "noOptionsAvailable": "Ei lisälaitteita valittuna"
    },
    "tyres": {
      "title": "Renkaat",
      "position": "Sijainti",
      "manufacturer": "Valmistaja",
      "dimensions": "Mitat",
      "loadIndex": "Kantavuusindeksi",
      "speedIndex": "Nopeusluokka",
      "season": "Kausi",
      "price": "Hinta",
      "noTyresAvailable": "Ei renkaita valittuna"
    },
    "mileageRates": {
      "title": "Kilometrikorvaukset",
      "baseRate": "Peruskorvaus",
      "mvaLess": "Alle rajan kilometrit",
      "mvaMore": "Yli rajan kilometrit",
      "noMileageRatesAvailable": "Kilometrikorvauksia ei ole saatavilla"
    }
  },
  "processStatus": {
    "categories": {
      "statusWithStep": "Tila - vaihe",
      "statusOnly": "Vain tila"
    },
    "status": {
      "quotationApproval": "Tarjouksen hyväksyntä",
      "orderApproval": "Tilauksen hyväksyntä",
      "orderProcessing": "Tilauksen käsittely",
      "orderUpdated": "Tilaus päivitetty",
      "delivery": "Toimitus",
      "quotationRejected": "Tarjous hylätty",
      "orderRejected": "Tilaus hylätty",
      "completed": "Valmis",
      "archived": "Arkistoitu"
    },
    "step": {
      "quotationApproval": {
        "notDefined": "Ei määritelty",
        "schemaFinalization": "Tarjouksen viimeistely",
        "parked": "Pysäköity",
        "driverApproval": "Odottaa kuljettajan hyväksyntää",
        "clientApproval": "Odottaa asiakkaan hyväksyntää",
        "hRApproval": "Odottaa HR:n hyväksyntää",
        "fleetManagerApproval": "Odottaa autovastaavan hyväksyntää",
        "supervisorApproval": "Odottaa esihenkilön hyväksyntää",
        "groupApproval": "Odottaa ryhmän hyväksyntää",
        "personApproval": "Odottaa henkilön hyväksyntää",
        "notRegisteredUserApproval": "Rekisteröimättömän käyttäjän hyväksyttäväksi",
        "purchaseSupportApproval": "Odottaa Purchase Support -hyväksyntää",
        "clientAccountAcceptation": "Odottaa CA-hyväksyntää",
        "orderCreation": "Tilauksen luominen",
        "completed": "Valmis"
      },
      "quotationRejected": {
        "rejection": "Hylkäys",
        "rejected": "Hylätty"
      },
      "delivery": {
        "parked": "Pysäköity",
        "notDefined": "Ei määritelty",
        "notActive": "Ei aktiivinen",
        "waiting": "Odottaa",
        "vehicleRegistration": "Ajoneuvon rekisteröinti",
        "handoverPreparation": "Luovutuksen valmistelu",
        "handover": "Valmis luovutettavaksi",
        "delivered": "Toimitettu",
        "completed": "Valmis"
      },
      "orderApproval": {
        "parked": "Pysäköity",
        "kamApproval": "KAM-hyväksyntä",
        "oDApproval": "OD-hyväksyntä",
        "deliveryConfirmation": "Toimitusvahvistus",
        "supplierAcceptation": "Toimittajan hyväksyntä",
        "supplierApproval": "Toimittajan hyväksyntä",
        "dealerAcceptation": "Jälleenmyyjän hyväksyntä",
        "dealerConfirmation": "Vahvistettu jälleenmyyjän toimesta",
        "dealerRejectionConfirmation": "Hylkäyksen vahvistus jälleenmyyjältä",
        "dealerRejection": "Jälleenmyyjän hylkäämä",
        "delivered": "Toimitettu",
        "notDefined": "Ei määritelty",
        "rejection": "Hylkäys",
        "rejected": "Hylätty",
        "completed": "Valmis"
      },
      "orderProcessing": {
        "parked": "Pysäköity",
        "waiting": "Odottaa",
        "supplierAcceptation": "Toimittajan hyväksyntä",
        "deliveryConfirmation": "Toimitusvahvistus",
        "delivered": "Toimitettu",
        "completed": "Valmis"
      },
      "orderUpdated": {
        "parked": "Pysäköity",
        "waiting": "Odottaa",
        "completed": "Valmis"
      },
      "orderRejected": {
        "notDefined": "Ei määritelty",
        "dealerRejection": "Jälleenmyyjän hylkäämä",
        "dealerRejectionConfirmation": "Hylkäyksen vahvistus jälleenmyyjältä",
        "supplierAcceptation": "Toimittajan hyväksyntä",
        "supplierApproval": "Toimittajan hyväksyntä",
        "rejection": "Hylkäys",
        "rejected": "Hylätty"
      },
      "completed": {
        "delivered": "Toimitettu",
        "completed": "Valmis"
      }
    },
    "combined": {
      "quotationSchemaFinalization": "Tarjous - Tarjouksen viimeistely",
      "quotationParked": "Tarjous - Pysäköity",
      "orderApprovalParked": "Tilauksen hyväksyntä - Pysäköity",
      "orderProcessingParked": "Tilauksen käsittely - Pysäköity",
      "orderUpdatedParked": "Päivitetty tilaus - Pysäköity",
      "deliveryParked": "Toimitus - Pysäköity",
      "quotationApprovals": "Tarjous - Hyväksynnät",
      "quotationClientApproval": "Tarjous - Odottaa asiakkaan hyväksyntää",
      "quotationClientAccountAcceptation": "Tarjous - Asiakastilin hyväksyntä",
      "quotationOrderCreation": "Tarjous - Tilaus luotu",
      "orderKamApproval": "Tilaus - KAM-hyväksyntä",
      "orderOdApproval": "Tilaus - OD-hyväksyntä",
      "orderDealerAcceptation": "Tilaus - Jälleenmyyjän hyväksyntä",
      "orderDealerConfirmation": "Tilaus - Jälleenmyyjän vahvistus",
      "orderProcessingWaiting": "Tilauksen käsittely - Odottaa",
      "orderUpdatedWaiting": "Tilaus päivitetty - Odottaa",
      "deliveryVehicleRegistration": "Toimitus - Ajoneuvon rekisteröinti",
      "deliveryHandoverPreparation": "Toimitus - Luovutuksen valmistelu",
      "deliveryHandover": "Toimitus - Luovutus",
      "tyreSupplierApproval": "Renkaat - Toimittajan hyväksyntä",
      "tyreSupplierAcceptation": "Renkaat - Toimittajan vastaanotto",
      "tyreDeliveryConfirmation": "Renkaat - Toimitusvahvistus",
      "tyreDelivered": "Renkaat - Toimitettu"
    },
    "actions": {
      "approve": "Hyväksy",
      "reject": "Hylkää",
      "submit": "Lähetä",
      "save": "Tallenna"
    },
    "manageApprovalFlow": "Hallinnoi hyväksyntäprosessia",
    "rejectReasonLabel": "Anna hylkäyksen syy",
    "rejectReasonPlaceholder": "Kirjoita syy...",
    "rejectReasonRequired": "Hylkäyksen syy on pakollinen",
    "actionRequiredQuotationSchemaFinalization": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationParked": "Työnkulku on pysäköity. Valitse, miten jatkat.",
    "actionRequiredQuotationOrderCreationEscapeHatch": "Kaikki ostotilaukset on pysäköity. Vapauta ne viimeistelemällä tilauksen luonti manuaalisesti.",
    "releaseParkedOrders": "Vapauta pysäköidyt tilaukset",
    "unpark": {
      "restartFromQuotation": "Käynnistä tarjouksesta",
      "restartFromPurchaseOrder": "Käynnistä ostotilauksesta",
      "noRestart": "Jatka ilman uudelleenkäynnistystä"
    },
    "actionRequiredQuotationDriverApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationHRApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationFleetManagerApproval": "Toimenpiteitä vaaditaan: Täytä ja tarkista alla olevat kentät. Kun tiedot on täytetty.",
    "actionRequiredQuotationClientApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationSupervisorApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationGroupApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationPersonApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationPurchaseSupportApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilausta.",
    "actionRequiredQuotationClientAdjustment": "Toimenpiteitä vaaditaan: Täytä ja tarkista alla olevat kentät. Kun tiedot on täytetty.",
    "actionRequiredQuotationClientAccountAcceptation": "Vahvistus vaaditaan: Anna tarjouksen numero ja hyväksy tai hylkää tarjous.",
    "actionRequiredQuotationRejection": "Toimenpiteitä vaaditaan: Tarjous on hylätty. Vahvista hylkäämisen viimeistely.",
    "actionRequiredVehicleOrderStepKamApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tilaus jatkaaksesi.",
    "actionRequiredVehicleOrderStepODApproval": "Toimenpiteitä vaaditaan: Tarkista alla oleva toimittaja ja hyväksy tai hylkää tilaus jatkaaksesi.",
    "actionRequiredVehicleOrderStepDealerAcceptation": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tilaus jatkaaksesi.",
    "actionRequiredVehicleOrderStepDealerConfirmation": "Toimenpiteitä vaaditaan: Syötä arvioitu toimituspäivä ja hyväksy tai hylkää tilaus.",
    "actionRequiredVehicleOrderStepDealerRejectionConfirmation": "Toimenpiteitä vaaditaan: Vahvista tilauksen hylkääminen.",
    "actionRequiredVehicleOrderStepDealerRejection": "Toimenpiteitä vaaditaan: Jälleenmyyjä on hylännyt tämän tilauksen. Vahvista hylkäämisen viimeistely.",
    "actionRequiredDeliveryStepWaiting": "Toimenpiteitä vaaditaan: Täytä VIN ja rekisterinumero.",
    "actionRequiredDeliveryStepVehicleRegistration": "Toimenpiteitä vaaditaan: Täytä  auton rekisteröintipäivä.",
    "actionRequiredDeliveryStepHandoverPreparation": "Toimenpiteitä vaaditaan: Vahvista toimitus ajankonta.",
    "actionRequiredDeliveryStepHandover": "Toimenpiteitä vaaditaan: Syötä tai vahvista ajoneuvon luovutuspäivämäärä ja kilometrimäärä.",
    "selectDriver": "Valitse kuljettaja",
    "replacedCarRegNumber": "Korvaavan auton rekisterinumero",
    "meaningOfReqDeliveryDate": "Pyydetyn toimituspäivän selitys",
    "requiredDeliveryDate": "Toivottu toimituspäivä",
    "possibleDeliveryDate": "Mahdollinen toimituspäivä",
    "vin": "VIN",
    "co2Emissions": "CO₂-päästöt",
    "registrationNumber": "Rekisterinumero",
    "registrationDate": "Rekisteröintipäivä",
    "socialSecurityNumber": "Sosiaaliturvatunnus",
    "initialQuotationNumber": "Alkuperäisen tarjouksen numero",
    "dealerExpectedDeliveryDate": "Arvioitu toimituspäivä",
    "expectedDeliveryDateInvalidTitle": "Virheellinen arvioitu toimituspäivä.",
    "expectedDeliveryDateInvalidMessage": "Arvioidun toimituspäivän on oltava myöhempi kuin mahdollinen toimituspäivä ja vähintään seitsemän arkipäivää tästä päivästä.",
    "registrationDateMustBeTodayMessage": "Rekisteröintipäivän on oltava sama kuin kuluva päivä.",
    "handoverDate": "Luovutuspäivä",
    "handoverMileage": "Luovutushetken kilometrit",
    "initialMileage": "Initial mileage",
    "actionRequiredTyreOrderStepSupplierApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää rengastilaus jatkaaksesi.",
    "actionRequiredTyreOrderStepSupplierAcceptation": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää rengastilaus jatkaaksesi.",
    "actionRequiredTyreOrderStepDeliveryConfirmation": "Toimenpiteitä vaaditaan: Vahvista toimitus ja kirjaa halutessasi rengassarjan toimitustiedot.",
    "actionRequiredTyreOrderStepRejection": "Toimenpiteitä vaaditaan: Toimittaja on hylännyt tämän rengastilauksen. Vahvista hylkäämisen viimeistely.",
    "secondTyreSetDeliveryInfo": "Kirjaa tähän tieto, mihin toinen rengassarja toimitettiin",
    "secondTyreSetDeliveryDate": "Toimituspäivä",
    "actionRequiredQuotationNotRegisteredUserApproval": "Toimenpiteitä vaaditaan: Hyväksy tai hylkää tarjous jatkaaksesi tilauksen käsittelyä.",
    "resendNotRegisteredUserApprovalLink": "Lähetä hyväksyntälinkki uudelleen"
  },
  "workflow": {
    "approval": {
      "title": "Työnkulun hyväksyntäprosessi",
      "description": "Hallinnoi tämän työnkulun hyväksyntävaiheita",
      "workflowId": "Työnkulun ID",
      "loading": "Ladataan hyväksyntäprosessia...",
      "addStep": "Lisää vaihe",
      "stepTypePlaceholder": "Valitse vaiheen tyyppi",
      "step": "Vaihe",
      "supervisorEmail": "Esimiehen sähköposti",
      "notRegisteredUserEmail": "Rekisteröimättömän käyttäjän sähköposti",
      "notRegisteredUserEmailRequired": "Anna tämän vaiheen sähköpostiosoite.",
      "supervisorEmailRequired": "Anna esimiehen sähköpostiosoite tälle vaiheelle.",
      "personPlaceholder": "Valitse henkilö...",
      "personRequired": "Valitse käyttäjä tälle vaiheelle.",
      "noEmployeesFound": "Tälle asiakkaalle ei löytynyt rekisteröityjä työntekijöitä.",
      "groupPlaceholder": "Valitse ryhmäpolku...",
      "groupRequired": "Valitse ryhmäpolku tälle vaiheelle.",
      "stepTypeRequired": "Valitse tyyppi jokaiselle vaiheelle jatkaaksesi.",
      "empty": "Mukautettuja hyväksyntävaiheita ei ole määritelty. Tallennuksen jälkeen käytetään oletusvaihetta Ostotuen hyväksyntä.",
      "addFirstStep": "Lisää mukautettu vaihe",
      "saveWorkflowAndClient": "Tallenna ja aseta asiakkaan oletukseksi",
      "saveWorkflowAndClientShort": "Tallenna & oletus",
      "save": "Tallenna tälle tarjoukselle",
      "saveShort": "Tallenna",
      "close": "Sulje",
      "error": "Hyväksyntäprosessia ei voitu ladata.",
      "saveSuccess": "Hyväksyntäprosessi tallennettu onnistuneesti.",
      "saveError": "Hyväksyntäprosessia ei voitu tallentaa.",
      "clientSaveSuccess": "Asiakkaan hyväksyntäprosessi tallennettiin.",
      "clientSaveError": "Asiakkaan hyväksyntäprosessia ei voitu tallentaa.",
      "stepTypes": {
        "driverApprovalStep": "Kuljettajan hyväksyntä",
        "hrApprovalStep": "HR-hyväksyntä",
        "fleetManagerApprovalStep": "Kalustopäällikön hyväksyntä",
        "purchaseSupportApprovalStep": "Ostotuen hyväksyntä",
        "supervisorApprovalStep": "Esimiehen hyväksyntä",
        "notRegisteredUserApprovalStep": "Rekisteröimättömän käyttäjän hyväksyntä",
        "groupApprovalStep": "Ryhmähyväksyntä",
        "personApprovalStep": "Henkilöhyväksyntä"
      }
    }
  },
  "notes": {
    "addNewNote": "Lisää uusi muistiinpano",
    "placeholderText": "Kirjoita muistiinpanosi...",
    "submitNote": "Lähetä muistiinpano",
    "noNotesYet": "Ei vielä muistiinpanoja",
    "noteAddedSuccessfully": "Muistiinpano lisätty onnistuneesti",
    "failedToAddNote": "Muistiinpanon lisääminen epäonnistui"
  },
  "clients": {
    "table": {
      "showing": "Tulokset",
      "of": "/",
      "loading": "Ladataan...",
      "columns": {
        "id": "ID",
        "name": "Nimi"
      },
      "search": {
        "global": "Hae ID:n tai asiakkaan nimen perusteella"
      }
    },
    "detail": {
      "title": "Asiakasyksityiskohdat",
      "description": "Hyväksyntäprosessin yleiskatsaus",
      "clientId": "Asiakas-ID",
      "loading": "Ladataan hyväksyntäprosessia...",
      "addStep": "Lisää vaihe",
      "stepTypePlaceholder": "Valitse vaiheen tyyppi",
      "step": "Vaihe",
      "supervisorEmail": "Esimiehen sähköposti",
      "notRegisteredUserEmail": "Rekisteröimättömän käyttäjän sähköposti",
      "personPlaceholder": "Valitse henkilö...",
      "personRequired": "Valitse tälle vaiheelle käyttäjä.",
      "noEmployeesFound": "Tälle asiakkaalle ei löytynyt rekisteröityjä työntekijöitä.",
      "groupPlaceholder": "Valitse ryhmäpolku...",
      "groupRequired": "Valitse tälle vaiheelle ryhmäpolku.",
      "stepTypeRequired": "Valitse jokaiselle vaiheelle tyyppi jatkaaksesi.",
      "empty": "Mukautettuja hyväksyntävaiheita ei ole määritelty. Tallennuksen jälkeen käytetään oletusvaihetta Ostotuen hyväksyntä.",
      "createFlow": "Luo mukautettu prosessi",
      "addFirstStep": "Lisää mukautettu vaihe",
      "applyDefaultFlow": "Käytä oletushyväksyntäprosessia",
      "save": "Tallenna",
      "close": "Sulje",
      "order": "Järjestys",
      "role": "Rooli",
      "group": "Ryhmä",
      "error": "Asiakastietoja ei voi ladata.",
      "stepDescriptionFallback": "Mukautettu hyväksyntävaihe",
      "defaultApplied": "Oletushyväksyntäprosessi otettu käyttöön.",
      "defaultApplyError": "Oletushyväksyntäprosessia ei voi ottaa käyttöön.",
      "customFlowCreated": "Mukautettu hyväksyntäprosessi luotu.",
      "customFlowCreateError": "Uutta hyväksyntäprosessia ei voi luoda.",
      "saveSuccess": "Hyväksyntäprosessi tallennettu onnistuneesti.",
      "saveError": "Hyväksyntäprosessia ei voi tallentaa.",
      "stepTypes": {
        "driverApprovalStep": "Kuljettajan hyväksyntä",
        "hrApprovalStep": "HR-hyväksyntä",
        "fleetManagerApprovalStep": "Kalustopäällikön hyväksyntä",
        "purchaseSupportApprovalStep": "Ostotuen hyväksyntä",
        "supervisorApprovalStep": "Esimiehen hyväksyntä",
        "notRegisteredUserApprovalStep": "Rekisteröimättömän käyttäjän hyväksyntä",
        "groupApprovalStep": "Ryhmähyväksyntä",
        "personApprovalStep": "Henkilöhyväksyntä"
      },
      "notice": {
        "custom": "Tämä asiakas käyttää mukautettua hyväksyntäprosessia.",
        "default": "Tämä asiakas käyttää tällä hetkellä oletushyväksyntäprosessia (Purchase Support Approval).",
        "empty": "Mukautettu hyväksyntäprosessi on tyhjä. Tallennuksen jälkeen oletusarvoinen Ostotuen hyväksyntä (PurchaseSupport Approval) otetaan automaattisesti käyttöön."
      }
    }
  },
  "documents": {
    "noDocumentsFound": "Asiakirjoja ei löytynyt",
    "uploadHint": "Voit ladata asiakirjan.",
    "uploadSuccess": "Tiedosto(t) ladattu onnistuneesti",
    "uploadError": "Tiedostojen lataaminen epäonnistui",
    "downloadError": "Tiedoston lataus epäonnistui"
  },
  "fileUpload": {
    "dragAndDrop": "Pudota tiedostot tai <span class=\"text-primary\">napsauta selataksesi</span>",
    "upload": "Lataa {count} tiedosto(a)",
    "removeFile": "Poista tiedosto",
    "maxFilesExceeded": "Voit valita enintään {max} tiedostoa kerralla.",
    "fileSizeHint": "Tiedoston enimmäiskoko on {maxSize}&nbsp;MB. Sallitut tiedostotyypit: {allowedTypes}.",
    "fileSizeExceeded": "Tiedosto {fileName} ylittää enimmäiskoon {maxSize} MB.",
    "fileTypeNotSupported": "Tiedosto {fileName} on väärää tyyppiä. Sallitut tiedostotyypit: {allowedTypes}."
  },
  "eventHistory": {
    "noRecords": "Historiatietoja ei löytynyt"
  },
  "workflowPublic": {
    "protectedAccess": "Suojattu pääsy",
    "description": "Tämän työnkulun tiedot on suojattu salasanalla.",
    "requestCodeDescription": "Nähdäksesi tämän työnkulun, pyydä pääsykoodi. Se lähetetään työnkulkuun liitettyyn sähköpostiosoitteeseen.",
    "sendAccessCode": "Lähetä pääsykoodi",
    "enterCode": "Syötä koodi",
    "codeSentDescription": "Syötä sähköpostiisi lähetetty 6-numeroinen koodi.",
    "verifyAccess": "Vahvista pääsy",
    "resendCode": "Lähetä koodi uudelleen",
    "resendIn": "Lähetä uudelleen {seconds}s kuluttua",
    "resendLimitReached": "Uudelleenlähetysten enimmäismäärä saavutettu",
    "codeSent": "Pääsykoodi lähetetty sähköpostiisi",
    "codeResent": "Uusi pääsykoodi on lähetetty sähköpostiisi",
    "verified": "Todennus onnistui",
    "approved": "Hyväksyntä lähetetty onnistuneesti",
    "retryIn": "Yritä uudelleen {minutes} minuutin kuluttua",
    "tryAgain": "Yritä uudelleen",
    "errors": {
      "expired": "Tämä hyväksyntälinkki on vanhentunut. Pyydä uusi.",
      "invalidCode": "Syöttämäsi koodi on virheellinen tai vanhentunut. Pyydä uusi koodi ja yritä uudelleen.",
      "rateLimited": "Liian monta yritystä. Odota hetki ja yritä uudelleen.",
      "sessionExpired": "Istuntosi on vanhentunut. Aloita alusta.",
      "forbidden": "Sinulla ei ole oikeutta suorittaa tätä toimintoa.",
      "serverError": "Jokin meni pieleen. Yritä myöhemmin uudelleen."
    },
    "errorTitles": {
      "expired": "Linkki vanhentunut",
      "invalidCode": "Virheellinen tai vanhentunut koodi",
      "rateLimited": "Liian monta yritystä",
      "unauthorized": "Istunto vanhentunut",
      "serverError": "Palvelinvirhe"
    }
  },
  "rejectModal": {
    "title": "Hylkää työnkulku",
    "reasonLabel": "Hylkäyksen syy",
    "reasonPlaceholder": "Anna hylkäyksen syy...",
    "initiatorLabel": "Hylkäyksen aloittaja",
    "initiatorPlaceholder": "Valitse kuka aloitti hylkäyksen...",
    "initiatorSupplier": "Toimittaja",
    "initiatorClient": "Asiakas",
    "cancel": "Peruuta",
    "confirm": "Hylkää"
  },
  "noAccess": {
    "title": "Pääsy estetty",
    "description": "Sinulla ei ole oikeutta tarkastella tätä sivua. Ota yhteyttä järjestelmänvalvojaan, jos uskot tämän olevan virhe.",
    "backHome": "Takaisin etusivulle"
  },
  "error": {
    "loadingData": "Tietojen lataaminen epäonnistui.",
    "apiDown": "Palvelin ei vastaa. Yritä myöhemmin uudelleen."
  }
}